module.exports = __webpack_public_path__ + "img/main_vf.f1668eb0.svg";